import fp from "lodash/fp"

import { createSplitsterValueSelector } from "common/services/utils/splitsterSelector"
import { SHOT_ACTIONS as SHOT_ACTION_CONSTANTS } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingScheduleChanges/consts/constants"

const formatPathOfDiff = path =>
  fp.tail(path.substring(0, path.indexOf("/departure") || path.indexOf("/arrival")).split("/"))

export const getScheduleChanges = (diff, original, updated) =>
  fp.compose(
    fp.map(path => ({
      departureCity: original.getIn([...path, "departure", "where", "name"]),
      departureCode: original.getIn([...path, "departure", "where", "code"]),
      arrivalCity: original.getIn([...path, "arrival", "where", "name"]),
      arrivalCode: original.getIn([...path, "arrival", "where", "code"]),
      arrivalOriginalWhen: original.getIn([...path, "arrival", "when", "local"]),
      arrivalUpdatedWhen: updated.getIn([...path, "arrival", "when", "local"]),
      departureOriginalWhen: original.getIn([...path, "departure", "when", "local"]),
      departureUpdatedWhen: updated.getIn([...path, "departure", "when", "local"]),
    })),
    fp.uniqWith(fp.isEqual),
    fp.filter(item => item.length !== 0 && !fp.includes("parts", item)),
    fp.map(item => formatPathOfDiff(item.path)),
    fp.filter(item => fp.includes("/when/", item.path)),
  )(diff.toJS())

export const shouldShowScheduleChangeModal = journeyDiff => {
  const rs = fp.compose(
    fp.filter(fp.endsWith("/when/local")),
    fp.map(fp.get("path")),
  )(journeyDiff.toJS())
  return !!rs.length
}

export const isActionRepair = scheduleChange =>
  scheduleChange && scheduleChange.get("action") === SHOT_ACTION_CONSTANTS.REPAIR

export const isLive = scheduleChange => scheduleChange && scheduleChange.get("live")

export const splitsterSHOTABtestVelueSelector = createSplitsterValueSelector("SHOT_LIVE")

export const isABTestSet = (scheduleChange, abTestValue) =>
  scheduleChange && scheduleChange.has("live") && abTestValue === "enabled"
